<template>
</template>
<script>
const imagePath = require("@/assets/mask_group_5.png");

export default {
  name: "Question",
  props: [
    "title",
    "text",
    "confirmButtonText",
    "cancelButtonText",
    "isConfirmedTitle",
    "isConfirmedText",
    "dismissTitle",
    "dismissText",
    "confirmButtonClasses",
    "cancelButtonClasses",
    "successIcon",
    "errorIcon",
  ],
  mounted() {
    const swalWithBootstrapButtons = this.$swal.mixin({
      customClass: {
        confirmButton: "question-btn-confirm",
        cancelButton: "question-btn-cancel mr-2",
      },
      buttonsStyling: false,
      showCloseButton: true,
      didClose: () => {
        this.$emit("didClose");
      },
    });

    swalWithBootstrapButtons
      .fire({
        title: this.title,
        text: this.text,
        //icon: "question",
        imageUrl: imagePath,
        imageHeight: 140,
        showCancelButton: true,
        confirmButtonText: this.confirmButtonText,
        cancelButtonText: this.cancelButtonText,
        reverseButtons: true,
        showClass: {
          popup: "animate__animated animate__fadeIn animate__faster",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOut animate__faster",
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          swalWithBootstrapButtons.fire({
            title: this.isConfirmedTitle,
            text: this.isConfirmedText,
            icon: this.successIcon,
            showConfirmButton: false,
            timer: 1500,
          });
          this.$emit("confirmed");
        } else if (
          result.dismiss === swalWithBootstrapButtons.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire({
            showClass: {
              popup: "animate__animated animate__fadeIn animate__faster",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOut animate__faster",
            },
            title: this.dismissTitle,
            text: this.dismissText,
            icon: this.errorIcon,
            showConfirmButton: false,
            timer: 1500,
          });
          this.$emit("notConfirmed");
        }
      });
  },
};
</script>